"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

require("core-js/modules/es6.function.bind.js");

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/extends"));

var _newArrowCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/newArrowCheck"));

var _react = _interopRequireDefault(require("react"));

var _Text = _interopRequireDefault(require("./Text"));

var _createTypo = _interopRequireDefault(require("./createTypo"));

var _this = void 0;

/**
 * Typography.Remark
 * @description 继承 Typography.Text API
 */
var Remark = function Remark(props) {
  (0, _newArrowCheck2["default"])(this, _this);
  return /*#__PURE__*/_react["default"].createElement(_Text["default"], (0, _extends2["default"])({}, props, {
    size: "t1",
    lineHeight: "md",
    strong: false,
    isCode: false
  }));
}.bind(void 0);

var WrappedRemark = (0, _createTypo["default"])(Remark, {
  limit: ["remark", "light", "white"],
  defaultColor: "remark"
}, false, "initial", "span");
var _default = WrappedRemark;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ucloud/ui-components/lib/components/Typography/Remark.js
// module id = 2076
// module chunks = 6 7 17 18